import React, { createContext, useContext, useState } from 'react';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    // Function to add a new toast message
    const addToast = (message, type = 'success', duration = 3000) => {
        const id = Date.now();
        const newToast = { id, message, type };
        setToasts(prev => [...prev, newToast]);
        setTimeout(() => {
            setToasts(prev => prev.filter(toast => toast.id !== id));
        }, duration);
    };

    return (
        <ToastContext.Provider value={addToast}>
            {children}
            {/* Toast Container */}
            <div className="fixed bottom-4 right-4 z-[9999] space-y-2 max-w-sm">
                {toasts.map(toast => (
                    <div
                        key={toast.id}
                        className={`px-6 py-3 rounded-xl shadow-lg text-white font-medium transform transition-all duration-300 animate-in slide-in-from-right-5 
              ${toast.type === 'success' ? 'bg-green-500' : toast.type === 'error' ? 'bg-red-500' : 'bg-yellow-500'}`}
                    >
                        <div className="flex items-center space-x-2">
                            <span className="text-lg">
                                {toast.type === 'success' ? '✅' : toast.type === 'error' ? '❌' : '⚠️'}
                            </span>
                            <span>{toast.message}</span>
                        </div>
                    </div>
                ))}
            </div>
        </ToastContext.Provider>
    );
};

// Custom hook for accessing the toast function
export const useToast = () => useContext(ToastContext);
